// extracted by mini-css-extract-plugin
export default {"depositBonus":"depositBonus_depositBonus__losuL"};